/*
  T10 form pages: the GHL calendar pop-up (loads the calendar only when opened), hiding #form buttons while
  there is no form, and ?issue= prefill on the form.
*/
(() => {
  const dialog = document.querySelector('[data-calendar]');
  document.querySelectorAll('[data-calendar-open]').forEach((btn) => {
    if (!dialog) { btn.hidden = true; return; }
    btn.addEventListener('click', () => {
      const frame = dialog.querySelector('iframe');
      if (!frame.src) frame.src = dialog.dataset.src;
      dialog.showModal();
    });
  });
  if (dialog) {
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog || e.target.closest('[data-calendar-close]')) dialog.close();
    });
  }

  // Buttons that jump to the form hide while the page has no form (stockist form ID still to come)
  if (!document.getElementById('form')) {
    document.querySelectorAll('a[href="#form"]').forEach((a) => { a.hidden = true; });
  }

  // ?issue= and ?topic= fill GHL fields whose query keys are set on the form block (topic: the returns page's Start your return)
  const params = new URLSearchParams(window.location.search);
  document.querySelectorAll('[data-form-prefill]').forEach((box) => {
    const frame = box.querySelector('iframe');
    if (!frame) return;
    const url = new URL(frame.src);
    let changed = false;
    [['issue', box.dataset.issueKey], ['topic', box.dataset.topicKey]].forEach(([param, key]) => {
      const value = params.get(param);
      if (value && key) { url.searchParams.set(key, value); changed = true; }
    });
    if (changed) frame.src = url.toString();
  });
})();
